import { render, staticRenderFns } from "./SubTable.vue?vue&type=template&id=6a146678&scoped=true&"
import script from "./SubTable.vue?vue&type=script&lang=js&"
export * from "./SubTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a146678",
  null
  
)

export default component.exports